import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const Whatsapp = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M12.25 3C7.42 3 3.5 6.92 3.5 11.75c0 1.92.61 3.7 1.66 5.14l-1.2 3.17 3.48-1.01c1.38.92 3.04 1.44 4.81 1.44 4.83 0 8.75-3.92 8.75-8.75S17.08 3 12.25 3Zm4.66 12.38-.94.92c-.98.98-3.59-.09-5.88-2.41-2.3-2.3-3.32-4.9-2.41-5.86l.94-.94c.35-.35.94-.35 1.31 0l1.38 1.38c.48.48.28 1.31-.35 1.51-.44.15-.74.63-.59 1.07.24 1.03 1.57 2.3 2.56 2.54.44.11.94-.15 1.07-.59.2-.63 1.03-.83 1.51-.35l1.38 1.38c.35.37.35.96.02 1.36v-.01Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Whatsapp
